import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Row } from 'reactstrap';

import CollectionsMiniGridItem from './GridItem';

const CollectionsMiniGrid = ({ collections, className }) => (
  <Row
    className={classnames(
      'gutter-20',
      'collections',
      className,
    )}
  >
    {collections.map(c => (
      <CollectionsMiniGridItem
        id={c.uuid}
        index={c.uuid}
        key={c.uuid}
        collection={c}
      />
    ))}
  </Row>
);

CollectionsMiniGrid.propTypes = {
  collections: PropTypes.array.isRequired,
  className: PropTypes.string,
};

CollectionsMiniGrid.defaultProps = {
  className: '',
};

export default CollectionsMiniGrid;
